import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const Pill = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="92" viewBox="0 0 92 47" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M68.3673 0.173401H23.7312C10.9896 0.173401 0.660461 10.5023 0.660461 23.2436C0.660461 35.985 10.9896 46.3139 23.7312 46.3139H68.3673C81.1089 46.3139 91.4381 35.985 91.4381 23.2436C91.4381 10.5023 81.1089 0.173401 68.3673 0.173401Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
